export default __webpack_public_path__ + "static/xpantia-logo-2666a0e70f905c1c82e6ccd47d1ac31d.png";